import type { SITE_WORKING_CONDITION_MODULATION_TABLE_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-working-condition-modulation-table/site-working-condition-modulation-table.fr.ts";

export const SITE_WORKING_CONDITION_MODULATION_TABLE_ENGLISH_LOCALE = {
  headers: {
    hwId: "Modulator Hw Id",
    csId: "Modulator Cs Id",
    name: "Device name",
    status: "Modulation status",
    modulationCount: "Modulation count",
    modulationLevel: "Level",
    lastModulationDate: "Last modulation",
    linkCsId: "Link Cs Id",
    appliance: "Appliance",
    link: "Link",
    modulator: "Modulator",
  },
  status: {
    NOT_TESTED: "Not Tested",
    NOK: "Ko Detected",
    OK: "Success",
  },
  modulationLevel: {
    NONE: "None",
    LOW: "Low",
    MEDIUM: "Normal",
    HIGH: "High",
  },
  empty: "No modulator",
} satisfies typeof SITE_WORKING_CONDITION_MODULATION_TABLE_FRENCH_LOCALE;
